import { render, staticRenderFns } from "./showHomePatient.vue?vue&type=template&id=56d315c1"
import script from "./showHomePatient.vue?vue&type=script&lang=js"
export * from "./showHomePatient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports